export const PACKAGE_FETCH_LIST = 'PACKAGE_FETCH_LIST';
export const PACKAGE_FETCH_LIST_SUCCESS = 'PACKAGE_FETCH_LIST_SUCCESS';
export const PACKAGE_FETCH_LIST_ERROR = 'PACKAGE_FETCH_LIST_ERROR';
export const PACKAGE_FETCH_LIST_CLEAN_STATE = 'PACKAGE_FETCH_LIST_CLEAN_STATE';

export const PACKAGE_LIST_SET_PAGE = 'PACKAGE_LIST_SET_PAGE';